<template>
  <div id="app">
    <!-- <h1>微医-移动端-H5</h1> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive"/>

    <zl-log />
  </div>
</template>

<script>
import zlLog from './components/zl-log.vue'

export default {
  name: 'App',
  components: {
    zlLog
  }
}
</script>

<style lang="less">
@import "./styles/base.less";
@import "./styles/variables.less";

// 默认隐藏 vconsole 工具
#__vconsole {
  display: none;
  &.show {
    display: block;
  }
}
#__zlLog {
  display: none;
  &.show {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue